<div class="config-page-container">
  <logo-config />
  <app-sharepoint-config *ngIf="sandboxEnabled" />
</div>
